<template>
  <Teleport to="body">
    <div class="toast-wrapper">
      <TransitionGroup name="toast-list">
        <div 
          v-for="toast in toastStore.toasts" 
          :key="toast.id" 
          class="toast-item"
          :class="`toast-item--${toast.type}`"
        >
          <div class="toast-icon">
            <span v-if="toast.type === 'success'">✓</span>
            <span v-else-if="toast.type === 'error'">✕</span>
            <span v-else-if="toast.type === 'warning'">⚠</span>
            <span v-else>ℹ</span>
          </div>
          <div class="toast-content">
            <p class="toast-title">{{ toast.title }}</p>
            <p v-if="toast.message" class="toast-message">{{ toast.message }}</p>
          </div>
          <button class="toast-close" @click="toastStore.removeToast(toast.id)">×</button>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script setup>
import { useToastStore } from '@/stores/toast'

const toastStore = useToastStore()
</script>

<style lang="scss" scoped>
@use '@/assets/styles/variables' as *;

.toast-wrapper {
  position: fixed;
  top: 20px;
  right: 20px;
  display: flex;
  flex-direction: column;
  gap: $spacing-sm;
  z-index: 9999;
  pointer-events: none;
}

.toast-item {
  display: flex;
  align-items: flex-start;
  gap: $spacing-sm;
  padding: $spacing-md $spacing-lg;
  background-color: $bg-card;
  border-radius: $border-radius;
  box-shadow: $shadow-lg;
  border-left: 4px solid;
  min-width: 300px;
  max-width: 450px;
  pointer-events: auto;
  
  &--success {
    border-left-color: $color-success;
    
    .toast-icon {
      color: $color-success;
      background-color: rgba($color-success, 0.1);
    }
  }
  
  &--error {
    border-left-color: $color-danger;
    
    .toast-icon {
      color: $color-danger;
      background-color: rgba($color-danger, 0.1);
    }
  }
  
  &--warning {
    border-left-color: $color-warning;
    
    .toast-icon {
      color: $color-warning;
      background-color: rgba($color-warning, 0.1);
    }
  }
  
  &--info {
    border-left-color: $color-info;
    
    .toast-icon {
      color: $color-info;
      background-color: rgba($color-info, 0.1);
    }
  }
}

.toast-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  flex-shrink: 0;
}

.toast-content {
  flex: 1;
  
  .toast-title {
    font-size: 14px;
    font-weight: 600;
    color: $text-primary;
    margin: 0;
  }
  
  .toast-message {
    font-size: 13px;
    color: $text-secondary;
    margin: 4px 0 0 0;
  }
}

.toast-close {
  background: none;
  border: none;
  font-size: 20px;
  color: $text-muted;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  
  &:hover {
    color: $text-primary;
  }
}

/* Transitions */
.toast-list-enter-active,
.toast-list-leave-active {
  transition: all 0.3s ease;
}

.toast-list-enter-from {
  opacity: 0;
  transform: translateX(100%);
}

.toast-list-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

.toast-list-move {
  transition: transform 0.3s ease;
}
</style>
